export default "__VITE_ASSET__c2fe69ee__"